import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { GridCol } from 'dibs-elements/exports/Grid';
import HpRespModuleItemTile from '../HpRespModuleItemTile/HpRespModuleItemTile';

import styles from './HpRespLocationsModuleItem.scss';

import { HpRespLocationsModuleItem_item } from './__generated__/HpRespLocationsModuleItem_item.graphql';

type Props = {
    item: HpRespLocationsModuleItem_item;
    onClick: () => void;
    useLazyLoadImages: boolean;
};

const HpRespLocationsModuleItem: FC<Props> = ({ item, onClick, useLazyLoadImages }) => {
    const { title, description, cta, linkData, imageUrl, imageHeight, imageWidth } = item;
    return (
        <GridCol tabletLandscape={3}>
            <div className={styles.item}>
                <HpRespModuleItemTile
                    linkData={linkData}
                    dataTn={`locations-module-item-${title}`}
                    onClick={onClick}
                    title={title}
                    description={description}
                    cta={cta}
                    imageUrl={imageUrl}
                    imgSrcSetWidths={[220, 360, 500, 760]}
                    imgSizes="(max-width:768px) 95vw, (max-width:1024px) 220px, 360px"
                    textClass={styles.tileText}
                    imageClass={styles.tileImage}
                    imageOverlayClass={styles.tileImageOverlay}
                    imageHeight={imageHeight}
                    imageWidth={imageWidth}
                    useLazyLoadImages={useLazyLoadImages}
                />
            </div>
        </GridCol>
    );
};

export default createFragmentContainer(HpRespLocationsModuleItem, {
    item: graphql`
        fragment HpRespLocationsModuleItem_item on Product {
            title
            description
            cta
            imageUrl
            imageHeight
            imageWidth
            linkData {
                ...HpRespModuleItemTile_linkData
            }
        }
    `,
});
